import { render } from "./NewMaterialUploadForm.vue?vue&type=template&id=61d0be4e"
import script from "./NewMaterialUploadForm.vue?vue&type=script&lang=js"
export * from "./NewMaterialUploadForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__